"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bookAgendaSlotApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const agenda_slot_reservation_1 = require("./agenda-slot-reservation");
exports.bookAgendaSlotApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('agenda-slots'),
        attributes: zod_1.z.object({}),
        relationships: zod_1.z.object({
            reservations: (0, api_1.apiEntityRelationshipSchema)('agenda-slot-reservations'),
        }),
    }),
    included: zod_1.z
        .array(zod_1.z.union([
        agenda_slot_reservation_1.agendaSlotReservationApiSchema,
        agenda_slot_reservation_1.slotReservationDoctorSubstituteSchema,
    ]))
        .optional()
        .default([]),
});
